module.exports = "<p>\n  weekly-column-chart works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/weekly-column-chart/weekly-column-chart.component.html
// module id = ../../../../../src/app/components/weekly-column-chart/weekly-column-chart.component.html
// module chunks = main